import * as S from "./GoBackLink.style";

import { ReactComponent as ArrowLeftIcon } from "assets/icons/left-arrow.svg";
import { useNavigate } from "react-router-dom";

const GoBackLink = ({ to, isUrl }) => {
  const navigate = useNavigate();

  return (
    <S.BackLink
      variant="primary-md-02"
      onClick={() => (isUrl ? (window.location.href = to) : navigate(to || -1))} //NOSONAR
    >
      <ArrowLeftIcon />
      Voltar
    </S.BackLink>
  );
};

export default GoBackLink;
